// import React from "react";
// import styles from "./VisaCard.module.css";

// function VisaCard({ visa }) {
//   const {
//     country,
//     duration,
//     fee,
//     description,
//     image,
//   } = visa;

//   return (
//     <div className={styles.visaCard}>
//       {image && (
//         <div className={styles.visaCardImageWrapper}>
//           <img
//             src={image}
//             alt={country}
//             className={styles.visaCardImage}
//           />
//         </div>
//       )}

//       <div className={styles.visaCardContent}>
//         {country && (
//           <h3 className={styles.visaCountry}>
//             {country}
//           </h3>
//         )}

//         <div className={styles.visaDetails}>
//           {duration && (
//             <p>
//               <span>Duration:</span> {duration}
//             </p>
//           )}

//           {fee && (
//             <p>
//               <span>Fee:</span> ₹ {fee}
//             </p>
//           )}
//         </div>

//         {description && (
//           <p className={styles.visaDescription}>
//             {description}
//           </p>
//         )}
//       </div>
//     </div>
//   );
// }

// export default VisaCard;


import React from "react";
import styles from "./VisaCard.module.css";

function VisaCard({ visa, showCategory }) {
  const {
    country,
    duration,
    fee,
    description,
    image,
    category,
  } = visa;

  return (
    <div className={styles.visaCard}>
      {image && (
        <div className={styles.visaCardImageWrapper}>
          <img
            src={image}
            alt={country}
            className={styles.visaCardImage}
          />
        </div>
      )}

      <div className={styles.visaCardContent}>
        {country && (
          <h3 className={styles.visaCountry}>
            {country}
          </h3>
        )}

        {showCategory && (
          <div
            className={`${styles.categoryBadge} ${
              styles[category]
            }`}
          >
            {category === "visa_free"
              ? "Visa Free"
              : category === "evisa_voa"
              ? "E-Visa / VOA"
              : "Visa Required"}
          </div>
        )}

        <div className={styles.visaDetails}>
          {duration && (
            <p>
              <span>Duration:</span> {duration}
            </p>
          )}

          {fee && (
            <p>
              <span>Fee:</span> ₹ {fee}
            </p>
          )}
        </div>

        {description && (
          <p className={styles.visaDescription}>
            {description}
          </p>
        )}
      </div>
    </div>
  );
}

export default VisaCard;